import { render } from "./teachingStat.vue?vue&type=template&id=19a8c51c&scoped=true"
import script from "./teachingStat.vue?vue&type=script&lang=js"
export * from "./teachingStat.vue?vue&type=script&lang=js"

import "./teachingStat.vue?vue&type=style&index=0&id=19a8c51c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a8c51c"]])

export default __exports__